// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"favorite-card_actionButton__1R93N"};